import React from 'react'
import clsx from 'clsx'
import { makeStyles, Button } from '@material-ui/core'

import i18n from '../../config/i18n'
import moment from 'moment'

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiButtonBase-root': {
      opacity: 0.3,
      minWidth: 30,
    },

    '& $activeLanguageBtn': {
      opacity: 1,
    },
  },
  activeLanguageBtn: {},
}))

const LanguageSwitch: React.FC<{ className?: string }> = ({ className }) => {
  const classes = useStyles()

  const handleLanguageChange = (language: 'de' | 'en') => () => {
    i18n.changeLanguage(language)
    moment.locale(language)
    localStorage.setItem('language', language)
  }

  return (
    <div className={clsx(classes.root, className)}>
      <Button
        className={clsx({
          [classes.activeLanguageBtn]: i18n.language === 'en',
        })}
        onClick={handleLanguageChange('en')}
      >
        EN
      </Button>
      <Button
        className={clsx({
          [classes.activeLanguageBtn]: i18n.language === 'de',
        })}
        onClick={handleLanguageChange('de')}
      >
        DE
      </Button>
    </div>
  )
}

export default LanguageSwitch
